import { eventBus } from './src-utils-event-bus.js';
import { t } from './src-utils-translations.js';
import { isBannerPage, updatePPAGInlineButton } from './src-utils-chat-banner-page-utils.js';
import { isDesignPage, updateDesignButtonState, hideDesignHelpButton } from './src-utils-chat-design-page-utils.js';
import { isHelpPanelAnywherePage, sendEventToHelpAnywherePanel } from './src-utils-chat-help-panel-utils.js';
import { isHelpCenterHomepage, isOrderHelpPage } from './src-utils-chat-page-utils.js';

const onMaximize = () => {
  eventBus.dispatch("CAafterMaximize", {});
  if (isHelpPanelAnywherePage()) {
    sendEventToHelpAnywherePanel("hideChatLoader");
    sendEventToHelpAnywherePanel("hideHelpPanel");
    sessionStorage.removeItem("CAUnreadMessage");
  }
  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t("chatting-text"), true, result.matchedStyle);
    }
  });
  if (isDesignPage()) {
    updateDesignButtonState(t("chatting-text"), true);
  }
};
const onChatReady = async (isChatEnabled) => {
  const isConversationBrowserClosed = sessionStorage.getItem("isConversationBrowserClosed");
  if (isConversationBrowserClosed) {
    sessionStorage.removeItem("isConversationBrowserClosed");
  }
  eventBus.dispatch("CAonChatInit", { isAgentAvailable: isChatEnabled });
  if (isHelpCenterHomepage()) {
    eventBus.on("helpCenterChatWidgetReady", () => {
      let count = 0;
      setInterval(() => {
        count += 1;
        eventBus.dispatch("CAonChatInit", { isAgentAvailable: isChatEnabled });
      }, 2e3);
      if (count > 3) {
        clearInterval(count);
      }
    });
  }
  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t("start-chat"), !isChatEnabled, result.matchedStyle);
    }
  });
  if (isHelpPanelAnywherePage()) {
    sendEventToHelpAnywherePanel("hideChatScriptLoader");
  } else if (isDesignPage()) {
    const buttonText = t("ca-message");
    updateDesignButtonState(buttonText, !isChatEnabled);
    if (!isChatEnabled) {
      hideDesignHelpButton();
    }
  } else if (isOrderHelpPage()) ; else ;
};
const onChatEstablished = () => {
  if (isHelpPanelAnywherePage()) {
    sendEventToHelpAnywherePanel("chatEstablished");
  }
};
const onSessionContinuation = () => {
  eventBus.dispatch("CAonSessionActive", {});
  if (isHelpCenterHomepage()) {
    eventBus.on("helpCenterChatWidgetReady", () => {
      eventBus.dispatch("CAonSessionActive", {});
    });
  }
  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t("chatting-text"), true, result.matchedStyle);
    }
  });
  if (isHelpPanelAnywherePage()) {
    sendEventToHelpAnywherePanel("hideHelpPanel");
    sendEventToHelpAnywherePanel("hideChatScriptLoader");
    sendEventToHelpAnywherePanel("hideChatLoader");
    document.addEventListener("helpPanelLoaded", () => {
      eventBus.dispatch("CAonSessionActive", {});
      sendEventToHelpAnywherePanel("hideHelpPanel");
      sendEventToHelpAnywherePanel("hideChatScriptLoader");
      sendEventToHelpAnywherePanel("hideChatLoader");
    });
  } else if (isHelpCenterHomepage()) {
    document.addEventListener("helpCenterCAEvent", () => {
      eventBus.dispatch("CAonSessionActive", {});
    });
  } else if (isDesignPage()) {
    updateDesignButtonState(t("chatting-text"), true);
  }
};
const onBackButtonClick = () => {
  sendEventToHelpAnywherePanel("showHelpPanel");
};

export { onBackButtonClick, onChatEstablished, onChatReady, onMaximize, onSessionContinuation };
//# sourceMappingURL=src-utils-chat-chat-event-handler.js.map
